import { IconAngleRight, IconDownload } from '@iwoca/icons';
import { Button, Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { CompletedStepItem } from '../../onboardingChecks/onboardingStepItem/CompletedStepItem';
import { Document } from '../types';
import { useFetchCreditCardDocumentContent } from '../useCreditCardDocumentContent';

const DocumentCardTitle = ({ title }: { title: Document['title'] }) => (
    <FormattedMessage
        id="_.credit_card.onboarding.document_card.read_and_sign"
        defaultMessage="Read and sign your {document}"
        values={{ document: title }}
    />
);

export const DocumentCard = ({
    document,
    onClick
}: {
    document: Document;
    onClick: (document: Document) => void;
}) => {
    const { refetch } = useFetchCreditCardDocumentContent({
        documentId: document.id,
        signingState: 'signed',
        fileFormat: 'pdf',
        enabled: false,
        suspense: false
    });
    return (
        <div data-testid={`document-${document.title}`}>
            {document.agreed ? (
                <CompletedStepItem>
                    <div className="flex flex-row justify-between">
                        <Text className="text-m font-med text-primary-10">
                            <DocumentCardTitle title={document.title} />
                        </Text>

                        <Button
                            variant="tertiary"
                            size="small"
                            className="mx-s"
                            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                            aria-label="download document"
                            onClick={() => refetch()}
                        >
                            <IconDownload className="fill-primary-40" />
                        </Button>
                    </div>
                </CompletedStepItem>
            ) : (
                <PendingDocumentCard document={document} onClick={onClick} />
            )}
        </div>
    );
};

const PendingDocumentCard = ({
    document,
    onClick
}: {
    document: Document;
    onClick: (document: Document) => void;
}) => {
    return (
        <div
            className="m-auto flex w-full flex-row gap-m border-b-[1px] border-b-secondary-90 py-l text-left"
            onClick={() => onClick(document)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(document);
                }
            }}
            role="button"
            tabIndex={0}
        >
            <Text className="text-m font-med text-primary-40">
                <DocumentCardTitle title={document.title} />
            </Text>
            <IconAngleRight className="my-auto fill-primary-40" fontSize={20} />
        </div>
    );
};
